<template>
  <label class="form-input-checkbox">
    <slot />

    <input type="checkbox"
      v-bind="$attrs"
      :checked="$attrs.value"
      @change="$emit('input', $event.target.checked)"
    />
  </label>
</template>

<script>
export default {
  name: 'VFormInputCheckbox',
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
.form-input-checkbox {
  position: relative;
  display: block;

  padding-left: $gridGutter * 2;

  input[type="checkbox"] {
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;

    width: $gridGutter;
    height: $gridGutter;

    cursor: pointer;
  }
}
</style>
